export default __webpack_public_path__ + "static/media/Logo_Horizontal_800.62dd8e70.png";